module.exports = __webpack_public_path__ + "img/paper_fail.178cb1d1.svg";